import React, { FC } from 'react'
import { IconProps, SIZES } from '../exports'

/* Styles ======================================================================================== */
import { ChequeStyled } from './cheque.styled'

const Cheque: FC<IconProps> = props => {
  const { size = 'md', isAnimated, color, ...others } = props
  const theme = {
    color: `${color ? color : 'currentColor'}`,
  }
  return (
    <ChequeStyled
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={isAnimated !== undefined ? 'is-animated' : ''}
      theme={theme.color}
      {...SIZES[size]}
      {...others}
    >
      <path
        d="M6 24H2V8H22M12 24H30V8H28M5 12.5714H9M5 16H16M5 19.4286H16"
        className="stroke stroke-path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 17.4579C27 18.1869 26.7882 18.771 26.3647 19.2103C25.9412 19.6495 25.4282 19.9393 24.8259 20.0794V20.9766C24.8259 21.3037 24.7929 21.5327 24.7271 21.6636C24.6706 21.7944 24.5812 21.8832 24.4588 21.9299C24.3459 21.9766 24.1906 22 23.9929 22C23.7953 22 23.6353 21.9766 23.5129 21.9299C23.4 21.8832 23.32 21.7991 23.2729 21.6776C23.2071 21.5187 23.1741 21.2804 23.1741 20.9626V20.0935C22.7882 20.0093 22.44 19.8692 22.1294 19.6729C21.8188 19.4766 21.6024 19.3037 21.48 19.1542L21.2965 18.9159C21.0988 18.6636 21 18.4439 21 18.257C21 18.0701 21.16 17.8224 21.48 17.514C21.6682 17.3364 21.8659 17.2477 22.0729 17.2477C22.2894 17.2477 22.5859 17.4346 22.9624 17.8084C23.2541 18.1636 23.5835 18.3411 23.9506 18.3411C24.6471 18.3411 24.9953 18.0561 24.9953 17.486C24.9953 17.2804 24.8635 17.1215 24.6 17.0093C24.3365 16.8972 24.0165 16.7991 23.64 16.715C23.2635 16.6215 22.8871 16.5 22.5106 16.3505C22.1341 16.2009 21.8141 15.9439 21.5506 15.5794C21.2871 15.215 21.1553 14.7523 21.1553 14.1916C21.1553 13.6308 21.3341 13.1262 21.6918 12.6776C22.0494 12.229 22.5435 11.9393 23.1741 11.8084V11.0234C23.1741 10.7056 23.2024 10.4766 23.2588 10.3364C23.3529 10.1121 23.6024 10 24.0071 10C24.2612 10 24.4494 10.0561 24.5718 10.1682C24.7035 10.271 24.7788 10.3832 24.7976 10.5047C24.8165 10.6262 24.8259 10.8037 24.8259 11.0374V11.8224C25.0894 11.8785 25.3294 11.9579 25.5459 12.0607C25.7624 12.1636 25.9129 12.2477 25.9976 12.3131L26.1247 12.4252L26.1812 12.4673C26.4165 12.6822 26.5341 12.8598 26.5341 13C26.5341 13.1402 26.4212 13.3738 26.1953 13.7009C25.9788 14.028 25.7388 14.1916 25.4753 14.1916C25.3059 14.1916 25.16 14.1495 25.0376 14.0654C24.9247 13.9813 24.8353 13.9112 24.7694 13.8551C24.7035 13.7991 24.6424 13.7523 24.5859 13.715C24.4259 13.6121 24.2235 13.5607 23.9788 13.5607C23.7341 13.5607 23.5318 13.6215 23.3718 13.743C23.2118 13.8551 23.1318 14.014 23.1318 14.2196C23.1318 14.4252 23.2259 14.5935 23.4141 14.7243C23.6118 14.8458 23.8518 14.9299 24.1341 14.9766C24.4165 15.014 24.7271 15.0841 25.0659 15.1869C25.4047 15.2804 25.7153 15.3925 25.9976 15.5234C26.28 15.6542 26.5153 15.8879 26.7035 16.2243C26.9012 16.5514 27 16.9626 27 17.4579Z"
        className="stroke fill stroke-path"
        strokeWidth="0.5"
      />
    </ChequeStyled>
  )
}

export default Cheque
